const routers = [
  {
    path: "/",
    auth: false,
    exact: true,
    redirect: "/auth/login",
  },
  {
    component: "AuthLayout",
    path: "/auth",
    redirect: "/auth/login",
    auth: false,
    exact: false,
    childrens: [
      {
        component: "Login",
        path: "/login",
        auth: false,
        exact: false,
      },
      {
        component: "ForgotPassword",
        path: "/forgotPassword",
        auth: false,
        exact: false,
      },
      {
        component: "ChangePassword",
        path: "/resetPassword/:name",
        auth: false,
        exact: false,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/admin",
    // redirect: '/admin/dashboard',
    auth: false,
    exact: false,
    childrens: [
      {
        component: "Dashboard",
        path: "/dashboard",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgdashboard",
      },
      {
        component: "NewDashboard",
        path: "/kpidashboard",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgkpidashboard",
      },
      {
        component: "SalesDashboard",
        path: "/salesdashboard",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgkpidashboard",
      },
      {
        component: "Billing",
        path: "/billing",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgbi",
      },
      {
        component: "CustomerReceipt",
        path: "/billing/print",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbilling",
      },

      {
        component: "CustomerReceipt",
        path: "/billing/print/bill/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbilling",
      },
      {
        component: "PayrollMain",
        path: "/payroll",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgpayroll",
      },
      {
        component: "Addpayroll",
        path: "/payroll/add",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgpayroll",
      },
      {
        component: "Addpayroll",
        path: "/payroll/edit/:id",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgpayroll",
      },
      {
        component: "TransactionHistory",
        path: "/transactionhistory",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "InsuranceDocument",
        path: "/insurance-document",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "EditInsurance",
        path: "/editinsurance/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "DownloadInsurance",
        path: "/downloadinsurance",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "TransactionReceipt",
        path: "/transactionhistory/print",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "TranscationSetting",
        path: "/transactionhistory/transcationSetting",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },

      {
        component: "TransactionReceipt",
        path: "/transactionhistory/print/bill/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "TransactionPriceChange",
        path: "/transactionhistory/pricechange",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "TransactionPriceChange",
        path: "/transactionhistory/pricechange/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flginvoices",
      },
      {
        component: "CartHome",
        path: "/cart/old",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgsales",
      },
      {
        component: "CartNew",
        path: "/cart",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgsales",
      },
      {
        component: "TreatmentDone",
        path: "/cart/treatment-done/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgsales",
      },
      {
        component: "BillOps",
        path: "/cart/bill-ops",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgsales",
      },
      {
        component: "Catalog",
        path: "/catalog",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcatalog",
      },
      // {
      //   component: "Payment",
      //   path: "/payment",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgpayment",
      // },
      // {
      //   component: "Payment",
      //   path: "/payment/:id",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgpayment",
      // },
      // {
      //   component: "ListSalons",
      //   path: "/salons",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgsalons"
      // },
      // {
      //   component: "CreateSalon",
      //   path: "/salons/add",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgsalons"
      // },
      // {
      //   component: "CreateSalon",
      //   path: "/salons/:id/editSaloon",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgsalons"
      // },
      // {
      //   component: "SalonDetails",
      //   path: "/salons/:id/salonDetails",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgsalons"
      // },
      // {
      //   component: "ListStaff",
      //   path: "/staff",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "AddStaff",
      //   path: "/staff/add",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "AddStaff",
      //   path: "/staff/:id/editStaff",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "StaffDetails",
      //   path: "/staff/:id/staffDetails",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "StaffAvailability",
      //   path: "/staff/availability",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      {
        component: "ListStaffPlus",
        path: "/staffplus",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "StaffPlusDetails",
        path: "/staffPlus/:id/staffDetails",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "StaffPlusAvailability",
        path: "/staffPlus/availability",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "StaffSkillList",
        path: "/staffplus/skills",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "AddStaffSkill",
        path: "/staffplus/skills/add",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "AddStaffPlus",
        path: "/staffplus/add",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "StaffSchedule",
        path: "/staffplus/schedule",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "SecurityAuthorization",
        path: "/staffplus/authorization",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "AddStaffPlus",
        path: "/staffplus/:id/editStaff",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "EmployeeInfo",
        path: "/staffplus/:id/empInfo",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgshowstaffmenu",
      },
      {
        component: "ListCustomerPlus",
        path: "/customerplus",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "Settings",
        path: "/customerplus/settings",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },

      {
        component: "CustomerPlusEditLayout",
        path: "/customerplus/settings/layout",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "LoyaltyPointsManagement",
        path: "/customerplus/:id/lpmanagement",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddManualPoints",
        path: "/customerplus/:id/lpmanagement/:type",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "LoyaltyPointsManagementSettings",
        path: "/customerplus/lpmanagement",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "CustomerOutlet",
        path: "/customerplus/customerOutlet",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "CustomerOutletStatus",
        path: "/customerplus/customerOutletStatus",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddRewardPolicy",
        path: "/customerplus/lpmanagement/addreward",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddRewardPolicy",
        path: "/customerplus/lpmanagement/:id/editreward",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddRedeemPolicy",
        path: "/customerplus/lpmanagement/addredeem",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddRedeemPolicy",
        path: "/customerplus/lpmanagement/:id/editredeem",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgcustomer",
      },
      {
        component: "AddCustomerPlus",
        path: "/customerplus/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "OutstandingCustomerPlus",
        path: "/customerplus/outstanding",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },

      {
        component: "AddCustomerPlus",
        path: "/customerplus/:id/editCustomer",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "CustomerDetailsPlus",
        path: "/customerplus/:id/details",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "AccountDetails",
        path: "/customerplus/:id/account",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "PettyCash",
        path: "/pettyCash",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgpettycash",
      },
      {
        component: "InvoiceHistorys",
        path: "/customerplus/:id/invoice",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "ProductPurchases",
        path: "/customerplus/:id/productpurchases",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "MemberGetMembers",
        path: "/customerplus/:id/membergetmembers",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "Documents",
        path: "/customerplus/:id/documents",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "Vouchers",
        path: "/customerplus/:id/vouchers",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "HoldSections",
        path: "/customerplus/:id/hold",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "PointPurchases_s",
        path: "/customerplus/:id/point",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "TreatmentDetails",
        path: "/customerplus/:id/treatment",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      {
        component: "TreatmentCourseDetails",
        path: "/customerplus/:id/treatment/:treatmentId/detail",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcustomer",
      },
      // {
      //   component: "ListCustomer",
      //   path: "/customer",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "AddCustomer",
      //   path: "/customer/add",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "AddCustomer",
      //   path: "/customer/:id/editCustomer",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CustomerDetails",
      //   path: "/customer/:id/details",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      {
        component: "NewListAppointment",
        path: "/newappointmentfullscreen",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      {
        component: "MobileListAppointment",
        path: "/mobileappointment",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },

      // {
      //   component: "ListAppointment",
      //   path: "/appointment",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "NewListAppointment",
        path: "/newappointment",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      {
        component: "SMSReply",
        path: "/newappointment/SMSReply",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      {
        component: "ConfirmBooking",
        path: "/newappointment/ConfirmBooking",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },

      // {
      //   component: "CreateAppointment",
      //   path: "/appointment/create",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "NewCreateAppointment",
        path: "/newappointment/create",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      {
        component: "InventoryMainPage",
        path: "/usage",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "StockSettings",
        path: "/usage/stocksettings",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "ListStockReport",
        path: "/usage/stockreport",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStockReport",
        path: "/usage/stockreport/add",
        auth: false,
        exact: true,
        rightskey: "flgusage",
      },
      {
        component: "AddStockReport",
        path: "/usage/stockreport/:id/edit",
        auth: false,
        exact: true,
        rightskey: "flgusage",
      },
      {
        component: "ListStockTake",
        path: "/usage/stocktake",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStockTake",
        path: "/usage/stocktake/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStockTake",
        path: "/usage/stocktake/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "ListStockMemo",
        path: "/usage/stockmemo",
        auth: false,
        exact: true,
        rightskey: "flgusage",
      },
      {
        component: "AddStockMemo",
        path: "/usage/stockmemo/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStockMemo",
        path: "/usage/stockmemo/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksTransferOut",
        path: "/usage/stockstransferout",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksTransferOut",
        path: "/usage/stockstransferout/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksTransferOut",
        path: "/usage/stockstransferout/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksTransferIn",
        path: "/usage/stockstransferin",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksTransferIn",
        path: "/usage/stockstransferin/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksTransferIn",
        path: "/usage/stockstransferin/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksAdjustment",
        path: "/usage/stocksadjustment",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksAdjustment",
        path: "/usage/stocksadjustment/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksAdjustment",
        path: "/usage/stocksadjustment/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksRTN",
        path: "/usage/stocksrtn",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksRTN",
        path: "/usage/stocksrtn/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksRTN",
        path: "/usage/stocksrtn/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksGRN",
        path: "/usage/stocksgrn",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksGRN",
        path: "/usage/stocksgrn/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksGRN",
        path: "/usage/stocksgrn/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksDO",
        path: "/usage/stocksdo",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksDO",
        path: "/usage/stocksdo/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksDO",
        path: "/usage/stocksdo/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksPOHQ",
        path: "/usage/stockspohq",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPOHQ",
        path: "/usage/stockspohq/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPOHQ",
        path: "/usage/stockspohq/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksPOApproved",
        path: "/usage/stockspoapproved",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPOApproved",
        path: "/usage/stockspoapproved/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPOApproved",
        path: "/usage/stockspoapproved/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "ListStocksPO",
        path: "/usage/stockspo",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPO",
        path: "/usage/stockspo/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },
      {
        component: "AddStocksPO",
        path: "/usage/stockspo/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgusage",
      },

      {
        component: "SmtpSettings",
        path: "/settings",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SmtpSettings",
        path: "/settings/smtpsettings",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SmtpCreate",
        path: "/settings/smtpsettings/add",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SmtpCreate",
        path: "/settings/smtpsettings/:id/edit",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SmtpDetails",
        path: "/settings/smtpsettings/:id/details",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      //{
      //   component: "InvoiceTemplete",
      //   path: "/backend/invoicetemplete",
      //   auth: false,
      //   exact: true,
      //   role: [],
      //   rightskey: "flgsettings",
      // },
      {
        component: "SetupTransaction",
        path: "/settings/setuptransaction",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SetupTransCreate",
        path: "/settings/setuptransaction/add",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SetupTransCreate",
        path: "/settings/setuptransaction/:id/edit",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      {
        component: "SetupTransDetails",
        path: "/settings/setuptransaction/:id/details",
        auth: false,
        exact: true,
        role: [],
        rightskey: "flgsettings",
      },
      // {
      //   component: "Treatment",
      //   path: "/appointment/create/treatment",
      //   auth: false,
      //   exact: true,
      // },
      // {
      //   component: "SelectTreatment",
      //   path: "/appointment/create/select-treatment",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "NewSelectTreatment",
        path: "/newappointment/create/select-treatment",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      // {
      //   component: "Payment",
      //   path: "/payment/appointment/:id",
      //   auth: false,
      //   exact: true,
      // },
      // {
      //   component: "AppointmentDetail",
      //   path: "/appointment/:id/detail",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "NewAppointmentDetail",
        path: "/newappointment/:id/detail",
        auth: false,
        exact: true,
        role: ["1", "2", "3", "4"],
        rightskey: "flgappt",
      },
      // {
      //   component: "ListService",
      //   path: "/service",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CreateService",
      //   path: "/service/add",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CreateService",
      //   path: "/service/:id/editServices",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "ServiceDetails",
      //   path: "/service/:id/serviceDetails",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "ListProduct",
      //   path: "/product",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CreateProduct",
      //   path: "/product/add",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "ProductDetails",
      //   path: "/product/productDetails",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "Review",
      //   path: "/review",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      {
        component: "DayEndSettlementModules",
         path: "/dayendsettlement",
         auth: false,
         exact: true,
         role: ["1", "2"],
         rightskey: "flgdayend", // changes by Praveen (add dayendsettlement menu )
      },
      {
        component: "DayEndReport",
        path: "/DayEndReport",
        auth: false,
        exact: true,
        role: ["1", "2"],
        rightskey: "flgdayend",
      },

      // {
      //   component: "viewUserDetail",
      //   path: "/users/viewDetail",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "Tournaments",
      //   path: "/tournaments",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "ViewTournamentDetails",
      //   path: "/tournaments/tournamentDetail",
      //   Auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CompletedTournamentDetail",
      //   path: "/tournaments/completedtournamentDetail",
      //   Auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "CreateTournament",
      //   path: "/tournaments/createtournament",
      //   Auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "BroadcastMessage",
      //   path: "/broadcastmessage",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      // {
      //   component: "Messages",
      //   path: "/broadcastmessage/messages",
      //   auth: false,
      //   exact: true,
      //   role: [],
      // },
      {
        component: "TCM",
        path: "/TCM",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgtcm",
      },
      {
        component: "TCMCustomerList",
        path: "/TCM/TCMCustomerList",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgtcm",
      },
      {
        component: "TCMPaymentList",
        path: "/TCM/TCMPaymentList",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgtcm",
      },
      {
        component: "Backend",
        path: "/backend",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      // {
      //   component: "BackendMenu",
      //   path: "/backend",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      //   rightskey: "flgbackend",
      // },
      {
        component: "DataEntry",
        path: "/backend/itemdataentrys",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "ItemMaster",
        path: "/backend/itemmaster",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Inventory",
        path: "/backend/inventory",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Division",
        path: "/backend/itemclassification/division",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Departmentlist",
        path: "/backend/itemclassification/department",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Departmentdata",
        path: "/backend/itemclassification/departmentdataentry",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclassdata",
        path: "/backend/itemclassification/classdataentry",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclasslist",
        path: "/backend/itemclassification/itemclasslist",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Brandlist",
        path: "/backend/itemclassification/brandlist",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Branddata",
        path: "/backend/itemclassification/branddataentry",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "ItemUOM",
        path: "/backend/itemclassification/uom",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Commissionlist",
        path: "/backend/itemclassification/commissionlist",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "CommissionData",
        path: "/backend/itemclassification/commissiondataentry",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclassproduct",
        path: "/backend/itemclassification/rangeproduct",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemrangeproduct",
        path: "/backend/itemclassification/range/product",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclassservice",
        path: "/backend/itemclassification/range/itemclassservice",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemrangeservice",
        path: "/backend/itemclassification/range/service",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclassvoucher",
        path: "/backend/itemclassification/range/classvoucher",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemrangevoucher",
        path: "/backend/itemclassification/range/voucher",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclassprepaid",
        path: "/backend/itemclassification/range/itemclassprepaid",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemrangeprepaid",
        path: "/backend/itemclassification/range/prepaid",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemclasscompound",
        path: "/backend/itemclassification/range/itemclasscompound",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemrangecompound",
        path: "/backend/itemclassification/range/compound",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Equipmentdetails",
        path: "/backend/appointment/equipemt",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Equipment",
        path: "/backend/appointment/equipment",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "AppointmentRoom",
        path: "/backend/appointment/room",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "InvoiceTemplete",
        path: "/backend/invoicetemplete",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Smtpsetting",
        path: "/backend/smtpsetting",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "CatalogSetting",
        path: "/backend/catalogsetting",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "AddDisplayItems",
        path: "/backend/catalogsetting/displayitems",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Appointmentblockreason",
        path: "/backend/appointment/blockreason",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Bookingstatus",
        path: "/backend/appointment/booking",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Bookingstatuslist",
        path: "/backend/appointment/bookingstatus",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Appointmentgroup",
        path: "/backend/appointment/appointmentgroup",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Appointmentchannel",
        path: "/backend/appointment/appointmentchannel",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Secondarystatuslist",
        path: "/backend/appointment/secondarystatus",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Secondarystatus",
        path: "/backend/appointment/secondary",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Adjustmentreason",
        path: "/backend/treatment/adjustmentreason",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Diagnosis",
        path: "/backend/treatment/diagnosis",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Discountreason",
        path: "/backend/sales/discountreason",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "FOCreason",
        path: "/backend/sales/focreason",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemstatus",
        path: "/backend/sales/itemstatus",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Itemstatusgroup",
        path: "/backend/sales/itemstatusgroup",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "PaymentType",
        path: "/backend/sales/paymenttype",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "PaymentGroup",
        path: "/backend/sales/paymentgroup",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "OccupationType",
        path: "/backend/configinterface/occupationtype",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Configsource",
        path: "/backend/configinterface/configsource",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Transactionreason",
        path: "/backend/configinterface/transactionreason",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Transactionvoid",
        path: "/backend/configinterface/transactionvoid",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Taxtype",
        path: "/backend/taxtype",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Outletmaster",
        path: "/backend/outletmaster",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "ImportBalance",
        path: "/backend/imports",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },

      {
        component: "Customermasterone",
        path: "/backend/customermasterone",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Customermastertwo",
        path: "/backend/customermastertwo",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Normalrewardpolicy",
        path: "/backend/normalrewardpolicy",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Redeempolicy",
        path: "/backend/redeempolicy",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "BonusReward",
        path: "/backend/bonusreward",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Vendormaster",
        path: "/backend/vendormaster",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Employeemaster",
        path: "/backend/employeemaster",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Securitymaster",
        path: "/backend/securitymaster",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Businesshours",
        path: "/backend/businesshours",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Countrysetting",
        path: "/backend/countrysetting",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Customermasterdetails",
        path: "/backend/customermaster/CustomerClass",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Corporatedetails",
        path: "/backend/customermaster/Corporatedetails",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Vendordetails",
        path: "/backend/vendore/vendoredetails",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditItem",
        path: "/backend/itemCode/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editequiment",
        path: "/backend/Equimentid/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editbookingstatus",
        path: "/backend/Bookinglistid/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editsecondarystatus",
        path: "/backend/Secondarylistid/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editproduct",
        path: "/backend/ProductId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editservice",
        path: "/backend/ServiceId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editvoucher",
        path: "/backend/VoucherId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editprepaid",
        path: "/backend/prepaidId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editcompound",
        path: "/backend/compoundId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editdivision",
        path: "/backend/divisionId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "Editdepartment",
        path: "/backend/departmentId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditItemclassdata",
        path: "/backend/classId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditBrand",
        path: "/backend/brandId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditCommission",
        path: "/backend/commissionId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditCorporate",
        path: "/backend/Corporate_Customerid/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditCustomermaster",
        path: "/backend/CustomerclassId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "EditVendor",
        path: "/backend/VendorId/:id",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbackend",
      },
      {
        component: "MGMPolicy",
        path: "/backend/mgm-policy",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgbilling",
      },
      {
        component: "QuantumMainPage",
        path: "/quantum",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddPO",
        path: "/quantum/po/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddPO",
        path: "/quantum/po/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddQuotation",
        path: "/quantum/quotation/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddQuotation",
        path: "/quantum/quotation/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "ManualListQuotation",
        path: "/quantum/manualinvoice",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },

      {
        component: "ManualAddQuotation",
        path: "/quantum/manualinvoice/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "ManualAddQuotation",
        path: "/quantum/manualinvoice/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "ListWorkOrderInvoice",
        path: "/quantum/workorderinvoice",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddWorkOrderInvoice",
        path: "/quantum/workorderinvoice/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "AddWorkOrderInvoice",
        path: "/quantum/workorderinvoice/:id/edit",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        component: "ListPO",
        path: "/po",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      // {
      //   component: "AddPO",
      //   path: "/po/add",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      // },
      // {
      //   component: "AddPO",
      //   path: "/po/:id/editPO",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      // },
      // {
      //   component: "ListQuotation",
      //   path: "/quotation",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      // },
      // {
      //   component: "AddQuotation",
      //   path: "/quotation/add",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      // },
      // {
      //   component: "AddQuotation",
      //   path: "/quotation/:id/editQuotation",
      //   auth: false,
      //   exact: true,
      //   role: ["1", "2", "3"],
      // },
      {
        component: "ListProject",
        path: "/project",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },

      {
        component: "AddProject",
        path: "/project/add",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "AddProject",
        path: "/project/:id/editProject",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "Commission",
        path: "/commission",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcommission",
      },
      {
        component: "Amountsetting",
        path: "/commission/Amountsetting",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcommission",
      },
      {
        component: "Staffcommission",
        path: "/commission/Staffcommission",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcommission",
      },
      {
        component: "Managercommission",
        path: "/commission/Managercommission",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcommission",
      },
      {
        component: "Monthlycommission",
        path: "/commission/Monthlycommission",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgcommission",
      },
      {
        component: "ReportsMenu",
        path: "/reportsmenu",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "NewReportsMenu",
        path: "/newreportsmenu",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "CollectionOutlet",
        path: "/collectionbyoutlet",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "PrintReport",
        path: "/collectionbyoutlet/printreport",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "ReportSettingsClass",
        path: "/reportsettings",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "Treatment",
        path: "/treatment",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "PrintTreatmentReports",
        path: "/treatment/print",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "Studio",
        path: "/studio",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
      {
        component: "StudioReports",
        path: "/studio/reports",
        auth: false,
        exact: true,
        role: ["1", "2", "3"],
        rightskey: "flgproject",
      },
    ],
  },
];

export default routers;
